export default {"src":"/_next/static/media/chevronRightWhite.b537ac67.svg","height":16,"width":10};